import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/app/packages/server/src/app/context.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/server/src/styles/global.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/server/src/components/Icons/styles.module.scss");
